import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { db } from './firebase';
import {
    collection, getDocs, query, orderBy, doc, updateDoc, addDoc
} from 'firebase/firestore';

import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction'; // for interactivity

function ClientCalendar() {
    const { id } = useParams();
    const [events, setEvents] = useState([]);

    useEffect(() => {
        fetchSessions();
    }, [id]);

    const fetchSessions = async () => {
        const sessionRef = collection(db, 'clients', id, 'sessions');
        const q = query(sessionRef, orderBy('createdAt', 'asc'));
        const snapshot = await getDocs(q);
        const eventList = snapshot.docs.map(docSnap => {
            const data = docSnap.data();
            const createdAt = data.createdAt?.toDate() || new Date();
            return {
                id: docSnap.id,
                title: data.therapist || 'Session',
                start: createdAt,
                extendedProps: {
                    note: data.note || '',
                }
            };
        });
        setEvents(eventList);
    };

    const handleDateClick = async (info) => {
        const therapist = prompt('Enter therapist name:');
        if (!therapist) return;

        const note = prompt('Enter session note:');
        if (note == null) return;

        const sessionRef = collection(db, 'clients', id, 'sessions');
        const docRef = await addDoc(sessionRef, {
            therapist,
            note,
            createdAt: new Date(info.dateStr),
        });

        // Refresh events
        fetchSessions();
    };

    const handleEventClick = (info) => {
        const note = info.event.extendedProps.note;
        alert(`📝 Session Note:\n\n${note}`);
    };

    const handleEventDrop = async (info) => {
        const newDate = info.event.start;
        const sessionId = info.event.id;

        const sessionDoc = doc(db, 'clients', id, 'sessions', sessionId);
        await updateDoc(sessionDoc, {
            createdAt: newDate,
        });

        alert('📅 Session date updated!');
    };

    return (
        <div className="p-6 font-sans">
            <Link to={`/client/${id}`} className="text-blue-600 hover:underline">
                ← Back to Client Detail
            </Link>

            <h2 className="text-2xl font-bold my-4">📅 Client Calendar</h2>

            <FullCalendar
                plugins={[dayGridPlugin, interactionPlugin]}
                initialView="dayGridMonth"
                events={events}
                dateClick={handleDateClick}
                eventClick={handleEventClick}
                editable={true}
                eventDrop={handleEventDrop}
                height="auto"
            />
        </div>
    );
}

export default ClientCalendar;
